export default __webpack_public_path__ + "static/media/witnesses.41eeba92.png";